import { render, staticRenderFns } from "./DepartmentAside.vue?vue&type=template&id=2d0c7136&scoped=true"
import script from "./DepartmentAside.vue?vue&type=script&lang=js"
export * from "./DepartmentAside.vue?vue&type=script&lang=js"
import style0 from "./DepartmentAside.vue?vue&type=style&index=0&id=2d0c7136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0c7136",
  null
  
)

export default component.exports